import { useLogto } from "@logto/react"
import { useCallback, useEffect, useState } from "react";
import { App, Button } from "antd";
import { LOGTO_RESOURCE } from "@src/utils/constants";
import useAutoLogin from "./useAutoLogin";

export const useAuthHeaders = () => {
  const { isAuthenticated, getAccessToken } = useLogto();
  const { autoSignIn } = useAutoLogin();
  const app = App.useApp();
  const getAuthHeader = useCallback(async (config?: { hideNotification?: boolean, noThrowError?: boolean }) => {
    if (!isAuthenticated) return;
    const token = await getAccessToken(LOGTO_RESOURCE);
    if (token) {
      const header = { Authorization: `Bearer ${token}` };
      return header;
    }
    if (!config?.hideNotification) {
      app.notification.warning({
        key: 'use-auth-headers-login-expired',
        title: '登陆已过期',
        duration: 20,
        actions: [
          <Button key='auto-signin' type="primary" onClick={() => autoSignIn() }>重新登陆</Button>
        ],
      });
    }
    if (config?.noThrowError) {
      return Promise.resolve(null);
    }
    return Promise.reject(new Error('Login expired'));
  }, [getAccessToken, isAuthenticated]);
  return { getAuthHeader };
}